import { GfxCacheResult } from "./clipping-studio-gfx-models";

export abstract class IClippingStudioGfxRepository {
  /** Materializes a GFX template on the server (download/extract/bridge). Returns cache result only, no URL. */
  abstract materializeGfx(instanceId: number): Promise<GfxCacheResult>;
  /**
   * Full serve URL for iframe src, including ?session=... from backend.
   * Append template params with & (e.g. serveUrl + '&TEXT1=' + encodeURIComponent(...)).
   * Throws or rejects on 404 — caller may retry materializeGfx.
   */
  abstract getGfxUrl(instanceId: number): Promise<string>;
}
